// Utility pure condivise dei flussi di tesseramento (PD/GD).
// Estrazioni a COMPORTAMENTO INVARIATO per de-duplicare logica ripetuta tra
// RegistrationPage, ProfilePage e cardsTab. Nessuno stato React qui: solo funzioni pure,
// così sono facilmente testabili e riducono la dimensione dei componenti.

/**
 * Assembla l'elenco tariffe dalla risposta di GET /active_rates.
 * Replica esattamente la logica finora duplicata nei componenti:
 *  - se presente, la free_offer va in testa;
 *  - seguono le tariffe entità (entity_rate[].rate);
 *  - la position_rate viene aggiunta in coda solo se valorizzata.
 *
 * @param {object} data - il corpo della risposta (response.data)
 * @returns {Array<object>} elenco tariffe
 */
export function parseActiveRatesResponse(data) {
  const source = data || {};
  const freeOffer = source.free_offer;
  const entityRates = Array.isArray(source.entity_rate) ? source.entity_rate.map((obj) => obj.rate) : [];
  const positionRate = source.position_rate ? source.position_rate.rate : {};
  const isPositionRateEmpty =
    !!positionRate && Object.keys(positionRate).length === 0 && positionRate.constructor === Object;

  const rates = freeOffer ? [freeOffer, ...entityRates] : [...entityRates];
  if (!isPositionRateEmpty) {
    rates.push(positionRate);
  }
  return rates;
}

/**
 * La tessera GD è pagabile solo con PayPal (tipo 'PCC'), mai bonifico.
 * Per il PD (o qualunque non-GD) restituisce tutti i metodi.
 *
 * @param {Array<object>} paymentTypes - elenco tipi di pagamento
 * @param {boolean} isGd - true se la tessera in pagamento è GD
 * @returns {Array<object>} metodi ammessi
 */
export function filterPaypalOnly(paymentTypes, isGd) {
  const list = Array.isArray(paymentTypes) ? paymentTypes : [];
  return isGd ? list.filter((type) => type.type === 'PCC') : list;
}
